/**
 * GOST関連コンポーネント専用i18n定数
 */

export const GOST_I18N = {
  // 食形態推奨（SCマップ対応）
  recommendations: {
    noOral: $localize`:@@home.gost.recommendations.noOral:絶飲食`,
    minimal: $localize`:@@home.gost.recommendations.minimal:最低限`,
    jelly: $localize`:@@home.gost.recommendations.jelly:ゼリー`,
    paste: $localize`:@@home.gost.recommendations.paste:ペースト食`,
    dysphagiaDiet: $localize`:@@home.gost.recommendations.dysphagiaDiet:嚥下調整食`,
    softDiet: $localize`:@@home.gost.recommendations.softDiet:軟菜食`,
    hospitalRegular: $localize`:@@home.gost.recommendations.hospitalRegular:病院普通食`,
    noRestriction: $localize`:@@home.gost.recommendations.noRestriction:制限なし`,
  },

  // 食形態説明
  descriptions: {
    noOral: $localize`:@@home.gost.descriptions.noOral:経口での飲食が全くおすすめできません`,
    minimal: $localize`:@@home.gost.descriptions.minimal:ごく少量の飲水や氷片など、最低限喉につまらないもの`,
    jelly: $localize`:@@home.gost.descriptions.jelly:ゼリー、ヨーグルト、プリンなど（可能であれば嚥下困難者用食品)`,
    paste: $localize`:@@home.gost.descriptions.paste:できる限り滑らかで性質が均一なもの（ピューレ食、ミキサー食なども含む）`,
    dysphagiaDiet: $localize`:@@home.gost.descriptions.dysphagiaDiet:噛むのに大きな苦労がなく、飲み込みも容易なもの(ミンチ状のものなども含む)`,
    softDiet: $localize`:@@home.gost.descriptions.softDiet:普通食と同じ食材を煮物などにして柔らかく調理したもの`,
    hospitalRegular: $localize`:@@home.gost.descriptions.hospitalRegular:餅など特に窒息リスクの高いものは極力避けたもの`,
    noRestriction: $localize`:@@home.gost.descriptions.noRestriction:お好きなものをお食べ下さい`,
  },

  // DSS説明
  dssDesc: {
    salivaAspiration: $localize`:@@home.gost.dssDesc.salivaAspiration:唾液誤嚥`,
    foodAspiration: $localize`:@@home.gost.dssDesc.foodAspiration:食物誤嚥`,
    liquidAspiration: $localize`:@@home.gost.dssDesc.liquidAspiration:水分誤嚥`,
    occasionalAspiration: $localize`:@@home.gost.dssDesc.occasionalAspiration:機会誤嚥`,
    oralProblem: $localize`:@@home.gost.dssDesc.oralProblem:口腔問題`,
    mildProblem: $localize`:@@home.gost.dssDesc.mildProblem:軽度問題`,
    normalRange: $localize`:@@home.gost.dssDesc.normalRange:正常範囲`,
    normal: $localize`:@@home.gost.dssDesc.normal:正常`,
  },

  // 共通メッセージ
  common: {
    noMatch: $localize`:@@home.gost.common.noMatch:該当なし`,
    noMatchDescription: $localize`:@@home.gost.common.noMatchDescription:該当する選択肢はありません`,
    notMeasured: $localize`:@@home.gost.common.notMeasured:未測定`,
    none: $localize`:@@home.gost.common.none:なし`,
  },

  // エラーメッセージ
  error: {
    outOfRange: $localize`:@@home.gost.error.outOfRange:条件外の入力値です`,
    filsOutOfRange: $localize`:@@home.gost.error.filsOutOfRange:FILS値が範囲外です。1から11の範囲で入力してください。`,
  },

  // 曜日
  weekdays: {
    sun: $localize`:@@home.gost.weekdays.sun:日`,
    mon: $localize`:@@home.gost.weekdays.mon:月`,
    tue: $localize`:@@home.gost.weekdays.tue:火`,
    wed: $localize`:@@home.gost.weekdays.wed:水`,
    thu: $localize`:@@home.gost.weekdays.thu:木`,
    fri: $localize`:@@home.gost.weekdays.fri:金`,
    sat: $localize`:@@home.gost.weekdays.sat:土`,
  },

  // 評価結果
  evaluation: {
    low: $localize`:@@home.gost.evaluation.low:低い`,
    high: $localize`:@@home.gost.evaluation.high:高い`,
    poor: $localize`:@@home.gost.evaluation.poor:不良`,
    good: $localize`:@@home.gost.evaluation.good:良好`,
  },

  // ランキング
  ranking: {
    first: $localize`:@@home.gost.ranking.first:1位`,
    second: $localize`:@@home.gost.ranking.second:2位`,
  },

  // セクションタイトル
  section: {
    gc: $localize`:@@home.gost.section.gc:全身状態（GC）`,
    gcDesc: $localize`:@@home.gost.section.gcDesc:全身に関する状態`,
    oc: $localize`:@@home.gost.section.oc:口腔機能と生活能力（OC）`,
    ocDesc: $localize`:@@home.gost.section.ocDesc:その他、嚥下に関わる状態`,
    sc: $localize`:@@home.gost.section.sc:水飲みテスト（SC）`,
    fils: $localize`:@@home.gost.section.fils:推定食事能力`,
  },

  // OC（口腔機能と生活能力）テーブル
  oc: {
    teeth: {
      label: $localize`:@@home.gost.oc.teeth.label:残存歯`,
      shortLabel: $localize`:@@home.gost.oc.teeth.shortLabel:歯`,
      options: [
        $localize`:@@home.gost.oc.teeth.opt1:<10本`,
        $localize`:@@home.gost.oc.teeth.opt2:10-20本`,
        $localize`:@@home.gost.oc.teeth.opt3:21-25本`,
        $localize`:@@home.gost.oc.teeth.opt4:>25本`,
      ],
    },
    denture: {
      label: $localize`:@@home.gost.oc.denture.label:義歯安定性`,
      shortLabel: $localize`:@@home.gost.oc.denture.shortLabel:義歯`,
      options: [
        $localize`:@@home.gost.oc.denture.opt1:義歯滑落`,
        $localize`:@@home.gost.oc.denture.opt2:義歯動揺`,
        $localize`:@@home.gost.oc.denture.opt3:義歯安定`,
        $localize`:@@home.gost.oc.denture.opt4:義歯不使用`,
      ],
    },
    oralHygiene: {
      label: $localize`:@@home.gost.oc.oralHygiene.label:口腔環境`,
      shortLabel: $localize`:@@home.gost.oc.oralHygiene.shortLabel:口腔`,
      options: [
        $localize`:@@home.gost.oc.oralHygiene.opt1:著明な汚染`,
        $localize`:@@home.gost.oc.oralHygiene.opt2:汚染あり`,
        $localize`:@@home.gost.oc.oralHygiene.opt3:舌苔あり齲歯あり`,
        $localize`:@@home.gost.oc.oralHygiene.opt4:汚染なし`,
      ],
    },
    articulationLevel: {
      label: $localize`:@@home.gost.oc.articulationLevel.label:発話能力\n（発話明瞭度）`,
      shortLabel: $localize`:@@home.gost.oc.articulationLevel.shortLabel:発話`,
      options: [
        $localize`:@@home.gost.oc.articulationLevel.opt1:全く聞き取り不能（5）`,
        $localize`:@@home.gost.oc.articulationLevel.opt2:時々わかる（3-4）`,
        $localize`:@@home.gost.oc.articulationLevel.opt3:時々わからない（2）`,
        $localize`:@@home.gost.oc.articulationLevel.opt4:よくわかる（1）`,
      ],
    },
    rightArm: {
      label: $localize`:@@home.gost.oc.rightArm.label:上肢機能・右\n（MMT、SIAS）`,
      shortLabel: $localize`:@@home.gost.oc.rightArm.shortLabel:右上肢`,
      options: [
        $localize`:@@home.gost.oc.rightArm.opt1:≦ほとんど動かない（0-1）`,
        $localize`:@@home.gost.oc.rightArm.opt2:挙上可能（2-3）`,
        $localize`:@@home.gost.oc.rightArm.opt3:弱い抵抗運動可能（3-4）`,
        $localize`:@@home.gost.oc.rightArm.opt4:強い抵抗運動可能（5）`,
      ],
    },
    leftArm: {
      label: $localize`:@@home.gost.oc.leftArm.label:上肢機能・左\n（MMT、SIAS）`,
      shortLabel: $localize`:@@home.gost.oc.leftArm.shortLabel:左上肢`,
      options: [
        $localize`:@@home.gost.oc.leftArm.opt1:≦ほとんど動かない（0-1）`,
        $localize`:@@home.gost.oc.leftArm.opt2:挙上可能（2-3）`,
        $localize`:@@home.gost.oc.leftArm.opt3:弱い抵抗運動可能（3-4）`,
        $localize`:@@home.gost.oc.leftArm.opt4:強い抵抗運動可能（5）`,
      ],
    },
    disabilityLevel: {
      label: $localize`:@@home.gost.oc.disabilityLevel.label:身体機能\n（障害高齢者の生活自立度）`,
      shortLabel: $localize`:@@home.gost.oc.disabilityLevel.shortLabel:身体`,
      options: [
        $localize`:@@home.gost.oc.disabilityLevel.opt1:ベッド上寝たきり（C）`,
        $localize`:@@home.gost.oc.disabilityLevel.opt2:車いす乗車可能（B）`,
        $localize`:@@home.gost.oc.disabilityLevel.opt3:臥床がち、歩行可能（A）`,
        $localize`:@@home.gost.oc.disabilityLevel.opt4:独力で外出可能（J～）`,
      ],
    },
    cognitiveLevel: {
      label: $localize`:@@home.gost.oc.cognitiveLevel.label:認知機能\n（認知症高齢者の生活自立度）`,
      shortLabel: $localize`:@@home.gost.oc.cognitiveLevel.shortLabel:認知`,
      options: [
        $localize`:@@home.gost.oc.cognitiveLevel.opt1:常時監視必要（IV-M）`,
        $localize`:@@home.gost.oc.cognitiveLevel.opt2:症状目立つ（III）`,
        $localize`:@@home.gost.oc.cognitiveLevel.opt3:時々症状あり（II）`,
        $localize`:@@home.gost.oc.cognitiveLevel.opt4:症状なし（I～）`,
      ],
    },
  },

  // GC（全身状態）テーブル
  gc: {
    consciousnessLevel: {
      label: $localize`:@@home.gost.gc.consciousnessLevel.label:意識レベル`,
      shortLabel: $localize`:@@home.gost.gc.consciousnessLevel.shortLabel:意識`,
      options: [
        $localize`:@@home.gost.gc.consciousnessLevel.opt1:無反応`,
        $localize`:@@home.gost.gc.consciousnessLevel.opt2:痛みに反応`,
        $localize`:@@home.gost.gc.consciousnessLevel.opt3:声掛けに反応`,
        $localize`:@@home.gost.gc.consciousnessLevel.opt4:覚醒`,
      ],
    },
    temperature: {
      label: $localize`:@@home.gost.gc.temperature.label:体温`,
      shortLabel: $localize`:@@home.gost.gc.temperature.shortLabel:体温`,
      options: [
        $localize`:@@home.gost.gc.temperature.opt1:≥ 40.0 ℃ `,
        $localize`:@@home.gost.gc.temperature.opt2:38.5-39.9 ℃  `,
        $localize`:@@home.gost.gc.temperature.opt3:37.5-38.4 ℃`,
        $localize`:@@home.gost.gc.temperature.opt4:< 37.5 ℃`,
      ],
    },
    pulseLevel: {
      label: $localize`:@@home.gost.gc.pulseLevel.label:脈拍数`,
      shortLabel: $localize`:@@home.gost.gc.pulseLevel.shortLabel:脈拍`,
      options: [
        $localize`:@@home.gost.gc.pulseLevel.opt1:>130bpm`,
        $localize`:@@home.gost.gc.pulseLevel.opt2:111-130bpm`,
        $localize`:@@home.gost.gc.pulseLevel.opt3:91-110bpm`,
        $localize`:@@home.gost.gc.pulseLevel.opt4:≦ 90 bpm`,
      ],
    },
    spo2: {
      label: $localize`:@@home.gost.gc.spo2.label:SpO2`,
      shortLabel: $localize`:@@home.gost.gc.spo2.shortLabel:SpO2`,
      options: [
        $localize`:@@home.gost.gc.spo2.opt1:≦ 91%`,
        $localize`:@@home.gost.gc.spo2.opt2:92-93%`,
        $localize`:@@home.gost.gc.spo2.opt3:94-95%`,
        $localize`:@@home.gost.gc.spo2.opt4:≧ 96%`,
      ],
    },
    breathLevel: {
      label: $localize`:@@home.gost.gc.breathLevel.label:呼吸回数`,
      shortLabel: $localize`:@@home.gost.gc.breathLevel.shortLabel:呼吸`,
      options: [
        $localize`:@@home.gost.gc.breathLevel.opt1:≧ 30回/分`,
        $localize`:@@home.gost.gc.breathLevel.opt2:25-29回/分`,
        $localize`:@@home.gost.gc.breathLevel.opt3:21-24回/分`,
        $localize`:@@home.gost.gc.breathLevel.opt4:≦ 20回/分`,
      ],
    },
    onOxygen: {
      label: $localize`:@@home.gost.gc.onOxygen.label:酸素療法`,
      shortLabel: $localize`:@@home.gost.gc.onOxygen.shortLabel:酸素`,
      options: [
        $localize`:@@home.gost.gc.onOxygen.opt1:PPV、HFNC、高流量`,
        $localize`:@@home.gost.gc.onOxygen.opt2:低流量`,
        $localize`:@@home.gost.gc.onOxygen.opt3:気管切開`,
        $localize`:@@home.gost.gc.onOxygen.opt4:なし`,
      ],
    },
    sputum: {
      label: $localize`:@@home.gost.gc.sputum.label:痰`,
      shortLabel: $localize`:@@home.gost.gc.sputum.shortLabel:痰`,
      options: [
        $localize`:@@home.gost.gc.sputum.opt1:吸引頻回`,
        $localize`:@@home.gost.gc.sputum.opt2:吸引あり`,
        $localize`:@@home.gost.gc.sputum.opt3:痰絡み or 自己喀痰あり\n吸引なし`,
        $localize`:@@home.gost.gc.sputum.opt4:なし`,
      ],
    },
  },

  // SC（水飲みテスト）テーブル
  sc: {
    swallowResult: {
      label: $localize`:@@home.gost.sc.swallowResult.label:嚥下の有無`,
      shortLabel: $localize`:@@home.gost.sc.swallowResult.shortLabel:嚥下`,
    },
    coughResult: {
      label: $localize`:@@home.gost.sc.coughResult.label:むせの有無`,
      shortLabel: $localize`:@@home.gost.sc.coughResult.shortLabel:むせ`,
    },
    otherAbnormality: {
      label: $localize`:@@home.gost.sc.otherAbnormality.label:注意項目`,
      shortLabel: $localize`:@@home.gost.sc.otherAbnormality.shortLabel:注意項目`,
    },
    swallowDelay: {
      label: $localize`:@@home.gost.sc.swallowDelay.label:嚥下の遅れ`,
      shortLabel: $localize`:@@home.gost.sc.swallowDelay.shortLabel:遅れ`,
    },
    abnormalSound: {
      label: $localize`:@@home.gost.sc.abnormalSound.label:音の異常`,
      shortLabel: $localize`:@@home.gost.sc.abnormalSound.shortLabel:音異常`,
    },
    multiSwallows: {
      label: $localize`:@@home.gost.sc.multiSwallows.label:複数回の嚥下`,
      shortLabel: $localize`:@@home.gost.sc.multiSwallows.shortLabel:多嚥下`,
    },
    throatClear: {
      label: $localize`:@@home.gost.sc.throatClear.label:咳払い・呼吸の乱れ`,
      shortLabel: $localize`:@@home.gost.sc.throatClear.shortLabel:咳払い`,
    },
    otherAbbration: {
      label: $localize`:@@home.gost.sc.otherAbbration.label:その他`,
      shortLabel: $localize`:@@home.gost.sc.otherAbbration.shortLabel:その他`,
    },
    testResult: {
      label: $localize`:@@home.gost.sc.testResult.label:テスト判定`,
      shortLabel: $localize`:@@home.gost.sc.testResult.shortLabel:判定`,
    },
  },

  // FOIS（食事能力レベル）
  fois: {
    fois1: {
      foodType: $localize`:@@home.gost.fois.fois1.foodType:経口摂取なし`,
      other: '',
    },
    fois2: {
      foodType: $localize`:@@home.gost.fois.fois2.foodType:お楽しみ、\n極少量`,
      other: '',
    },
    fois3: {
      foodType: $localize`:@@home.gost.fois.fois3.foodType:ゼリー`,
      other: $localize`:@@home.gost.fois.fois3.other:嚥下調整食0-1`,
    },
    fois4: {
      foodType: $localize`:@@home.gost.fois.fois4.foodType:ペースト食`,
      other: $localize`:@@home.gost.fois.fois4.other:嚥下調整食2`,
    },
    fois5m: {
      foodType: $localize`:@@home.gost.fois.fois5m.foodType:刻み食`,
      other: $localize`:@@home.gost.fois.fois5m.other:嚥下調整食3`,
    },
    fois5p: {
      foodType: $localize`:@@home.gost.fois.fois5p.foodType:軟菜食`,
      other: $localize`:@@home.gost.fois.fois5p.other:嚥下調整食4`,
    },
    fois6: {
      foodType: $localize`:@@home.gost.fois.fois6.foodType:常食、\n一部制限あり`,
      other: '',
    },
    fois7: {
      foodType: $localize`:@@home.gost.fois.fois7.foodType:常食・\n制限なし`,
      other: '',
    },
  },

  // GC行カテゴリ（gost-recording用）
  gcRows: {
    awakening: {
      category: $localize`:@@home.gost.gcRows.awakening.category:覚醒`,
      values: [
        $localize`:@@home.gost.gcRows.awakening.val1:無反応`,
        $localize`:@@home.gost.gcRows.awakening.val2:痛みで反応`,
        $localize`:@@home.gost.gcRows.awakening.val3:呼びかけに反応`,
        $localize`:@@home.gost.gcRows.awakening.val4:覚醒`,
      ],
    },
    temperature: {
      category: $localize`:@@home.gost.gcRows.temperature.category:体温`,
      values: [
        $localize`:@@home.gost.gcRows.temperature.val1:≧40℃`,
        $localize`:@@home.gost.gcRows.temperature.val2:40.0℃＞`,
        $localize`:@@home.gost.gcRows.temperature.val3:38.5℃≧`,
        $localize`:@@home.gost.gcRows.temperature.val4:37.5℃≧`,
      ],
    },
    pulse: {
      category: $localize`:@@home.gost.gcRows.pulse.category:脈拍数`,
      values: [
        $localize`:@@home.gost.gcRows.pulse.val1:＞130bpm`,
        $localize`:@@home.gost.gcRows.pulse.val2:111-130bpm`,
        $localize`:@@home.gost.gcRows.pulse.val3:91-110bpm`,
        $localize`:@@home.gost.gcRows.pulse.val4:90bpm≧`,
      ],
    },
    spo2: {
      category: $localize`:@@home.gost.gcRows.spo2.category:SpO2`,
      values: [
        $localize`:@@home.gost.gcRows.spo2.val1:~91%`,
        $localize`:@@home.gost.gcRows.spo2.val2:92-93%`,
        $localize`:@@home.gost.gcRows.spo2.val3:94-95%`,
        $localize`:@@home.gost.gcRows.spo2.val4:96%≦`,
      ],
    },
    breath: {
      category: $localize`:@@home.gost.gcRows.breath.category:呼吸回数`,
      values: [
        $localize`:@@home.gost.gcRows.breath.val1:≧30回/分`,
        $localize`:@@home.gost.gcRows.breath.val2:25-29回/分`,
        $localize`:@@home.gost.gcRows.breath.val3:21-24回/分`,
        $localize`:@@home.gost.gcRows.breath.val4:20回/分≧`,
      ],
    },
    oxygen: {
      category: $localize`:@@home.gost.gcRows.oxygen.category:酸素療法`,
      values: [
        $localize`:@@home.gost.gcRows.oxygen.val1:PPV、HFNC、高流量`,
        $localize`:@@home.gost.gcRows.oxygen.val2:低流量`,
        $localize`:@@home.gost.gcRows.oxygen.val3:気管切開`,
        $localize`:@@home.gost.gcRows.oxygen.val4:なし`,
      ],
    },
    sputum: {
      category: $localize`:@@home.gost.gcRows.sputum.category:痰`,
      values: [
        $localize`:@@home.gost.gcRows.sputum.val1:吸引頻回`,
        $localize`:@@home.gost.gcRows.sputum.val2:吸引あり`,
        $localize`:@@home.gost.gcRows.sputum.val3:痰絡み or 自己喀痰あり\n吸引なし`,
        $localize`:@@home.gost.gcRows.sputum.val4:なし`,
      ],
    },
  },

  // MWST/FoodTestの結果
  mwst: {
    results: [
      { value: 1, description: $localize`:@@home.gost.mwst.result1:嚥下なし、むせるand/or呼吸切迫` },
      { value: 2, description: $localize`:@@home.gost.mwst.result2:嚥下あり、呼吸切迫` },
      { value: 3, description: $localize`:@@home.gost.mwst.result3:嚥下あり、呼吸良好、むせるand/or湿性嗄声` },
      { value: 4, description: $localize`:@@home.gost.mwst.result4:嚥下あり、呼吸良好、むせなし` },
      { value: 5, description: $localize`:@@home.gost.mwst.result5:４に加え、反復嚥下が30秒以内に２回可能` },
    ],
  },

  foodTest: {
    results: [
      { value: 1, description: $localize`:@@home.gost.foodTest.result1:嚥下なし、むせるand/or呼吸切迫` },
      { value: 2, description: $localize`:@@home.gost.foodTest.result2:嚥下あり、呼吸切迫` },
      { value: 3, description: $localize`:@@home.gost.foodTest.result3:嚥下あり、呼吸良好、むせるand/or湿性嗄声、口腔内残留中等度` },
      { value: 4, description: $localize`:@@home.gost.foodTest.result4:嚥下あり、呼吸良好、むせなし` },
      { value: 5, description: $localize`:@@home.gost.foodTest.result5:４に加え、反復嚥下が30秒以内に２回可能` },
    ],
  },

  // 単位
  unit: {
    seconds: $localize`:@@home.gost.unit.seconds:秒`,
    yearsOld: $localize`:@@home.gost.unit.yearsOld:歳`,
  },
} as const;

export type GostI18n = typeof GOST_I18N;

// 配列形式で使用するためのヘルパー関数
export function getRecommendationsArray(): string[] {
  return [
    GOST_I18N.recommendations.noOral,
    GOST_I18N.recommendations.minimal,
    GOST_I18N.recommendations.jelly,
    GOST_I18N.recommendations.paste,
    GOST_I18N.recommendations.dysphagiaDiet,
    GOST_I18N.recommendations.softDiet,
    GOST_I18N.recommendations.hospitalRegular,
    GOST_I18N.recommendations.noRestriction,
  ];
}

export function getDescriptionsArray(): string[] {
  return [
    GOST_I18N.descriptions.noOral,
    GOST_I18N.descriptions.minimal,
    GOST_I18N.descriptions.jelly,
    GOST_I18N.descriptions.paste,
    GOST_I18N.descriptions.dysphagiaDiet,
    GOST_I18N.descriptions.softDiet,
    GOST_I18N.descriptions.hospitalRegular,
    GOST_I18N.descriptions.noRestriction,
  ];
}

export function getDssDescArray(): string[] {
  return [
    GOST_I18N.dssDesc.salivaAspiration,
    GOST_I18N.dssDesc.foodAspiration,
    GOST_I18N.dssDesc.liquidAspiration,
    GOST_I18N.dssDesc.occasionalAspiration,
    GOST_I18N.dssDesc.oralProblem,
    GOST_I18N.dssDesc.mildProblem,
    GOST_I18N.dssDesc.normalRange,
    GOST_I18N.dssDesc.normal,
  ];
}

export function getWeekdaysArray(): string[] {
  return [
    GOST_I18N.weekdays.sun,
    GOST_I18N.weekdays.mon,
    GOST_I18N.weekdays.tue,
    GOST_I18N.weekdays.wed,
    GOST_I18N.weekdays.thu,
    GOST_I18N.weekdays.fri,
    GOST_I18N.weekdays.sat,
  ];
}
